module.exports = __webpack_public_path__ + "static/media/ic_logo_test.13bfaa65.svg";